import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const SendEmailClient = async (data) => {
  return await axios.post(`${BASE_URL}/api/client/envoyeEmailClient`, data, {
    headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
    }
  });
}


export { SendEmailClient }